module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/saturation-4c3507067eacb4e66a225c92f16ca265.svg";